import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import PicoLoader from "../Common/PicoLoader";
import Avatar from "./Avatar";
import SingleAvatar from "./SingleAvatar";
import {data} from "../../../Store/Actions/DataAction";
import {connect} from "react-redux";
import blueButton from "../../../assets/images/btn_blue_radius_setting.png";
import DialogContent from "@material-ui/core/DialogContent";
import ShopDialog from "../Common/ShopDialog";
import Dialog from "@material-ui/core/Dialog";
import AvatarBuyDialog from "../Common/AvatarBuyDialog";
import axios from "axios";
import {avatarList} from "../../../Utility/Url";
import {
    avatarDialogBackgroundColor, avatarDialogContentColor,
    dialogBackground,
    dialogBorderColor,
    dialogContentColor,
    dialogContentTextColor
} from "../../../Utility/Theme";
import contactUs from "../../../assets/images/contact_us.png";
import Item from "./Item";

class AvatarDialog extends React.Component{
    constructor() {
        super();
        this.state={
            picoSmallLoader:false,
            justify:'flex-end',
            gender:'boy',
            dialogDetail:null
        }
    }
    handleDirection=(gen)=>{
        const {justify,gender}=this.state
        if ( gen!== gender){
            if (justify==='flex-start'){
                this.setState({
                    justify:'flex-end'
                })
            }
            else if(justify==='flex-end'){
                this.setState({
                    justify:'flex-start'
                })
            }
            if (gender==='girl'){
                this.setState({
                    gender:'boy'
                })
            }
            else if(gender==='boy'){
                this.setState({
                    gender:'girl'
                })
            }
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.avatars && this.state.picoSmallLoader)
            this.setState({
                picoSmallLoader:false
            })
    }
    toggleIndexNav=()=> {

    }
    handleDialog=(data)=>{
        const obg ={
            dialog:{
                success:false,
                data:data,
                ok:{
                    action: "#cancel",
                    text: 'ثبت!',
                    backgroundColor:'green'
                },
                message:'خرید اواتار',
                style: {

                    background:avatarDialogBackgroundColor ,
                    borderColor: dialogBorderColor,
                    contentColor:avatarDialogContentColor,
                    contentTextColor: dialogContentTextColor,
                    type: "danger",
                },
                cancel:{
                    action: "#cancel",
                    text: 'منصرف شدم!'
                }
            }

        }
        this.setState({
            dialogDetail:obg.dialog,
            showDialog:true
        })
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    componentDidMount() {
        console.log(this.props)
    }

    render() {
        const {avatars}=this.props
        const {picoSmallLoader,justify,gender}=this.state
        const {name,avatar}=this.props.UserData.userData.userInfo
        const {dialogDetail}=this.state
        const data= {
            icon:avatar
        }
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'transparent',
                borderColor:'transparent',
                backgroundLess:true
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        const dialogTitle= {
            id:'',
            text:'اواتار',
            icon:'',
            textColor:'#ffffff',
            onClick:'none',
            fullHeight:false,
        }
        const backButton= {
            id:'',
            text:'بازگشت',
            icon:'',
            textColor:'#ffffff',
            onClick:'none'
        }
        return (
            // <Grid item sm={12} xs={12} alignItems={"center"} justify={'center'} container
            // style={{backgroundColor:'#3E0448',borderRadius:'20px',border:'2px solid grey',
            //     overflow:'hidden'
            // }}>
            <Grid container alignItems={"center"} justify={"center"} style={{background:
                    '',height:'100%'}}>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <AvatarBuyDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                {
                    (!picoSmallLoader && avatars)&&
                    <Grid container justify={"center"} alignItems={"center"}
                          style={{height:'100%'}}
                    >
                        {/*<Grid container xs={12} sm={12} >*/}
                        {/*    <Item fullHeight={false} data={dialogTitle} toggleIndexNav={this.toggleIndexNav} />*/}
                        {/*</Grid>*/}
                        <Grid style={{marginTop:'10px'}} sm={3} xs={3} container justify={"center"} alignItems={"center"}>
                            <SingleAvatar data={data}/>
                            <p style={{textAlign:'center',color:'#ffffff'}}>
                                {name}
                            </p>
                        </Grid>
                        <Grid sm={11} xs={11} direction={"row-reverse"} container justify={justify} alignItems={"center"}
                              className='gender-toggle'>

                            <Grid sm={6} xs={6} container justify={"center"} alignItems={"center"}
                                  className='gender-toggle-holder'>
                                <img className='gender-toggle-icon' style={{height:'100%'}} src={blueButton} alt=""/>
                            </Grid>

                            <Grid sm={6} xs={6} container justify={"center"} alignItems={"center"}
                                  onClick={()=>{this.handleDirection('girl')}}
                            >
                                <p className='gender-toggle-text'>زن</p>
                            </Grid>
                            <Grid sm={6} xs={6} container justify={"center"} alignItems={"center"}
                                  onClick={()=>{this.handleDirection('boy')}}
                            >
                                <p className='gender-toggle-text'>مرد</p>
                            </Grid>
                        </Grid>
                        <Grid className='setting-dialog-avatar' container style={{overflowY:'scroll',position:'relative',height:'300px'}}>
                            {
                                avatars.list[gender].map(data => {
                                    return (
                                        <Grid container style={{padding: '5px'}} alignItems={"center"}
                                              justify={"space-between"} xs={4} sm={4}
                                              onClick={()=>{
                                                  this.handleDialog(data)
                                              }}
                                        >
                                            <Avatar data={data}/>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                        {/*<Grid container  xs={6} sm={6} alignItems={"center"} justify={"center"}*/}
                        {/*      onClick={this.props.closeDialog}*/}
                        {/*>*/}
                        {/*    <Item data={backButton}*/}
                        {/*          toggleIndexNav={this.toggleIndexNav} />*/}
                        {/*</Grid>*/}
                    </Grid>
                }
                {
                    picoSmallLoader &&
                    <Grid sm={2} xs={2} container alignItems={"center"} justify={"center"} style={{position:'relative'}}>
                        <Grid item container justify={"center"} alignItems={"center"}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>

            // </Grid>
        )
    }

}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data})(AvatarDialog)